import React, { useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import { locales } from '../../translations/locales';


const ButtonSession = (props) => {
    const { setMenuOpen, session, locale, setLocale, theme } = props;

    useEffect(() => {
        //
    }, [session]);

    return (
        <>
            {
                session && !session.isValide ?
                    (
                        <div className="slide-r-nav-flag mt-2 p-2">
                            <img
                                src='./images/locale/fr.webp'
                                data-tip data-tooltip-id='flag'
                                onClick={() => setLocale('FR')}
                                className='flag m-1 p-1 float-left'
                                alt='français'
                            />
                            <img
                                src='./images/locale/en.webp'
                                data-tip data-tooltip-id='flag'
                                onClick={() => setLocale('EN')}
                                className='flag m-1 p-1 float-right'
                                alt='anglais'
                            />
                            <Tooltip id='flag' place='top' effect='solid' className='text-center'>
                                {locales[locale].chooseLangage}
                            </Tooltip>
                        </div>
                    ) :
                    ''
            }
            <div
                className={`btn buttonSession b-${theme === 'DARK' ? 'dark' : 'light'}`}
                onClick={session && session.isValide ? () => setMenuOpen(true) : () => { }}
                data-toggle={session && session.isValide ? '' : `modal`}
                data-target={session && session.isValide ? '' : `#modal`}
            >
                <>{session && session.isValide ? session.userName : locales[locale].session.logSign}</>
            </div>
        </>
    );
};

export default ButtonSession;
